class TaskPublishPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'task_publish.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'task_publish._m';

    // Create regular task publish excluding manual
    static CREATE = 'task_publish.create';

    // Create manual task publish
    static CREATE_MANUAL = 'task_publish.create.manual';

    // Create custom task publish
    static CREATE_CUSTOM = 'task_publish.create.custom';
}

export default TaskPublishPermission;
